import React from "react";
import style from "./style.module.css";
import Image from "next/image";

function index(props) {
  return (
    <div className={style.card}>
      <div className={style.img}>
        {/* <img
          src={props.backgroundUrl}
          alt={props.title}
          width={90}
          height={90}
        /> */}
        <Image
          unoptimized
          src={props.backgroundUrl}
          alt={props.title}
          width={90}
          height={90}
        />
      </div>
      <div className={style.texts}>
        <div className={style.descDiv}>
          <p className={style.title}>{props.title}</p>
          <p className={style.description}>{props.content}</p>
        </div>
      </div>
    </div>
  );
}

export default index;
